import React from 'react';
import type { PageHeaderProps } from '../../types/ui';

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  eyebrow,
  actions,
}) => (
  <div className='flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between'>
    <div className='min-w-0'>
      {eyebrow ? (
        <p className='mb-1 text-sm font-semibold text-primary-600 dark:text-primary-400'>
          {eyebrow}
        </p>
      ) : null}
      <h1 className='text-2xl font-bold tracking-tight text-secondary-950 dark:text-white sm:text-3xl'>
        {title}
      </h1>
      {description ? (
        <p className='mt-1 max-w-3xl text-sm leading-6 text-secondary-500 dark:text-secondary-400'>
          {description}
        </p>
      ) : null}
    </div>
    {actions ? (
      <div className='flex shrink-0 flex-wrap items-center gap-2'>{actions}</div>
    ) : null}
  </div>
);

export default PageHeader;
